export const constants = {
  APPLICATION_ROOT: 'root',
  AUTH_COOKIE_TRANSPORT: 'ULTA_AUTH_TRANSPORT',
  AUTH_EMAIL_TRANSPORT: 'ULTA_AUTH_EMAIL_TRANSPORT',
  AUTH_ACCOUNT_UNLOCK: 'ULTA_AUTH_ACCOUNT_UNLOCK',
  UNLOCK_ACCOUNT_ERROR_PATH: '/guestservices/unlock-account-error',
  AUTH_ERROR_TRANSPORT: 'ULTA_AUTH_ERROR',
  AUTH_ERROR_SEP_TOKEN: '|||',
  AUTH0_COOKIE: 'auth0',
  AUTH0_COMPAT_COOKIE: 'auth0_compat',
  COLUMN_CONTAINER_BREAKPOINTS: {
    XL: 'extraLargeDevice',
    LG: 'largeDevice',
    MD: 'mediumDevice',
    SM: 'smallDevice'
  },
  COMAPCTDEALCARD_IMAGE_DIMENSIONS: {
    singleImage: [123, 158, 192, 212],
    multiImage: [60, 97, 118, 129]
  },
  CVV: {
    AMEXCARD_FORMATTER: { pattern: '9999' },
    OTHERCARD_FORMATTER: { pattern: '999' }
  },
  DATACAPTURE_EVENT_TYPE: {
    viewport: 'viewport',
    click: 'click',
    response: 'response'
  },
  DELIVERY_TYPE: {
    PICKUP: 'pickup',
    SHIP: 'ship',
    DELIVERY: 'delivery'
  },
  ENTER_KEY: 13,
  ESC_KEY: 27,
  EVENTS: {
    UPDATE_APP_CONFIG: 'updateAppConfig',
    UPDATE_GPC_PREFERENCES: 'updateGpcPreferences'
  },
  FORMATTER_PATTERNS: {
    CREDITCARD_FORMATTER_AMEX: { pattern: '9999 999999 99999' },
    CREDITCARD_FORMATTER: { pattern: '9999 9999 9999 9999' },
    DASHED_PHONE_NUMBER: { pattern: '999-999-9999' },
    DOB_FORMATTER: { pattern: '99/99' },
    DOB_YEAR_FORMATTER: { pattern: '99/99/9999' },
    EXPDATE_FORMATTER: { pattern: '99/99' },
    PHONE_NO_FORMATTER: { pattern: '(999) 999-9999' },
    REWARDS_ID_FORMATTER: { pattern: '9999999999999' },
    SSN_FORMATTER: { pattern: '999-99-9999', hidden: '***-**-9999' },
    ZIPCODE_FORMATTER: { pattern: '99999' },
    OTP_FORMATTER: { pattern: '999999' }
  },
  GIFTCARD: {
    NUMBERFORMATTER: '9999 9999 9999 9999',
    PINFORMATTER: '999999999'
  },
  HFN: {
    IncrementalModuleName: 'IncrementalModule',
    MainWrapperModuleName: 'MainWrapper',
    TopBarModuleName: 'TopBar',
    FooterModuleName: 'Footer',
    header: '/header',
    footer: '/footer',
    href: '{href}',
    EXTERNAL_HEADER: 'header-ds',
    EXTERNAL_FOOTER: 'footer-ds'
  },
  INTERSECTION_OBSERVER_OPTIONS: {
    rootMargin: '0px',
    root: null,
    threshold: [0, 0.25, 0.5, 0.75, 1]
  },
  ITEMS_PER_PAGE: 96,
  LEFTARROW_KEY: 37,
  LOGIN_STATUS: {
    SOFT_LOGIN: 'softLogin',
    HARD_LOGIN: 'hardLogin',
    ANONYMOUS: 'anonymous'
  },
  MINNUS_KEY: 189,
  OVERLAY_BACKDROP_Z_INDEX: 4,
  PAYPALBUTTON: {
    PAYMENT_TYPE: 'paypal',
    STYLE: {
      LABEL: 'pay', // oneOf( 'pay', 'paypal', 'buynow', 'checkout', 'installment' )
      SIZE: 'responsive', // oneOf( 'small', 'medium', 'large', 'responsive' )
      COLOR: 'gold', // oneOf( 'silver , 'white', 'black', 'gold', 'blue' )
      SHAPE: 'rect' // oneOf( 'rect', 'pill' )
    },
    FLOW: 'vault',
    LOCALE: 'en_US',
    CURRENCY: 'USD' // Required currency
  },
  PICKUP_STORE_AVAILABILITY_STATUS: {
    COMPLETELY_AVAILABLE: 'completelyAvailable'
  },
  PLUS_KEY: 187,
  PREVIEWDATE_COOKIE: 'X-ULTA-PREVIEW-DATE',
  PRODUCT_HIGHLIGHTER_VISIBILITY_LENGTH: 3,
  REGEX_PATTERNS: {
    nicknameRegex: '^(?! )[ A-Za-z0-9_@&.,/\\[\\]()^?-]*$',
    nameoncardRegex: '^(?! )[ A-Za-z0-9_@&.,/\\[\\]()^?-]*$',
    firstNameRegex: '^(?! )[ A-Za-z0-9_@&.,/\\[\\]()^?-]*$',
    lastNameRegex: '^(?! )[ A-Za-z0-9_@&.,/\\[\\]()^?-]*$',
    phoneNumberRegex: '^((\\([2-9][0-9][0-9]\\))|\\d{3})[- ]?\\d{3}[- ]?\\d{4}$',
    zipCodeOrCityRegex: /^[a-zA-Z ,]+$|\b\d{5,}\b/,
    dashedPhoneNumberRegex: '^[2-9]\\d{2}-\\d{3}-\\d{4}$',
    emailRegex: '^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$'
  },
  RIGHTARROW_KEY: 39,
  SAVE_FOR_LATER_OPTIONS: {
    FLYOUT: 'flyout'
  },
  SEARCH_HEADER_PATH: '/searchHeader',
  SEARCH_MOBILE_MODAL_CLASS: 'SearchMobile',
  SEARCH_PARAM: 'search',
  SNACKBAR_DISPLAY_DURATION: 5000,
  SPACER_IGNORED_MODULES: ['GamBanner'],
  STAGING_HOST_COOKIE: 'X-ULTA-STAGING-HOST',
  TAB_KEY: 9,
  TEALIUM_LINK_EVENT_TIMEOUT: 1000,
  ULTA_SITE_COOKIE: 'X_ULTA_SITE',
  UPARROW_KEY: 38,

  URGENCY_TAG_TYPE: {
    THREE_PLUS_DAYS: '3+ days',
    TWO_DAYS: '2 days',
    ONE_DAY: '1 day',
    HOURS: 'Hours',
    EXTENDED: 'Extended',
    UPCOMING: 'Upcoming',
    TIMER: 'Timer'
  },
  SPACE_KEY: 32,
  DOWNARROW_KEY: 40
};

export default constants;
